/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsForSaasBase {
    getFixupPrototypeFunction() { return FilterOptionsForSaasBase.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsForSaasBase>): FilterOptionsForSaasBase {
        let obj = Object.assign(new FilterOptionsForSaasBase(), model);
        FilterOptionsForSaasBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsForSaasBase>): FilterOptionsForSaasBase {
        if (!model) return null;
        return FilterOptionsForSaasBase.newInstance(<FilterOptionsForSaasBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsForSaasBase) {
        if (!obj) return;

        models.FilterOptionsForSaasBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsForSaasBase): boolean {
        Object.setPrototypeOf(obj, FilterOptionsForSaasBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.saas_accounts) {
            for (let val of this.saas_accounts) {
                models.FilterOptionsSaasAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * List of accounts for this SaaS Provider
     */
    saas_accounts: Array<models.FilterOptionsSaasAccount>;

    /**
     * Currencies
     */
    currencies: Array<models.Currency>;

}
